import { useState } from "react";
import { AddForm, UploadFileComp, useTitle } from "../../components";
import { useAddApplicantMutation, } from "../../store";
import { ToastContainer, toast } from "react-toastify";
import { toastOptions } from "../../utils/error";

export default function AddApplicant() {
    useTitle("Add Applicant");

    const [file, setFile] = useState(null);
    const [info, setInfo] = useState({ link: null, client_name: null });
    const [UpdateCompError, setUpdateCompError] = useState(null);

    const [addApplicant, { isLoading, isSuccess, error }] =
        useAddApplicantMutation();
    console.log(UpdateCompError);
    //submit
    const handleSubmit = (e) => {
        e.preventDefault();
        addApplicant({ applicant: info.applicant });
    };

    const bannerAttr = [
        {
            type: "text",
            col: 12,
            props: {
                label: "Applicant",
                name: "applicant",
                placeholder: "Enter Applicant",
            },
        },
    ];

    return (
        <AddForm
            title="Add Applicant"
            data={info}
            setData={setInfo}
            inputFieldProps={bannerAttr}
            submitHandler={handleSubmit}
            target="/admin/applicant"
            successMessage="Applicant Added Successfully!"
            reducerProps={{ loading: isLoading, error: error, success: isSuccess }}
        >
            <ToastContainer />
        </AddForm>
    );
}